import React, { useState, useEffect, useCallback } from "react";
import { usePlaidLink } from "react-plaid-link";
import {
    getLinkToken,
    exchangePublicToken,
} from "../../api/plaidClient";

export default function LinkAccount({ onLinkSuccess }) {
    const [linkToken, setLinkToken] = useState("");
    const [error, setError] = useState("");

    const onSuccess = useCallback(
        async (public_token) => {
            try {
                await exchangePublicToken(public_token);
                if (onLinkSuccess) {
                    onLinkSuccess();
                } else {
                    window.location.reload();
                }
            } catch (e) {
                console.error(e);
                setError("Could not exchange public token. Please try again.");
            }
        },
        [onLinkSuccess]
    );

    const { open, ready, error: plaidError } = usePlaidLink({
        token: linkToken,
        onSuccess,
    });

    useEffect(() => {
        getLinkToken()
            .then((token) => {
                setLinkToken(token);
            })
            .catch((e) => {
                console.error(e);
                setError("Unable to fetch Link Token. Please refresh.");
            });
    }, []);

    if (error || plaidError) {
        return (
            <p className="text-sm text-danger-500">
                {error || plaidError.message}
            </p>
        );
    }

    if (!linkToken) {
        return (
            <span className="text-sm text-gray-500">
                Loading...
            </span>
        );
    }

    return (
        <div className="shrink-0 sm:text-right">
            <button
                onClick={() => open()}
                disabled={!ready}
                className="btn-primary"
            >
                {ready ? (
                    <>
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Connect Account
                    </>
                ) : (
                    "Loading..."
                )}
            </button>
            <p className="text-xs text-gray-500 mt-2">
                You'll log in through Plaid's secure portal. OmniWorth never sees your password.
            </p>
        </div>
    );
}
